<template>
  <b-card class="col-md-4 offset-md-4 justify-content-center login"
            title="Login"
    >
    <form>
      <b-form-input v-model="data.username" type="text" name="login" placeholder="Enter your name"></b-form-input>
      <b-form-input v-model="data.password" type="password" name="password" placeholder="Enter your password" @keyup.enter.prevent.native="login"></b-form-input>
    </form>
    <b-button variant="primary" @click="login">Login</b-button>
    </b-card>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      context: 'login context',
      e1: true,
      data: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    loginEnable () {
      return !this.data.username || !this.data.password
    }
  },
  methods: {
    login () {
      // var redirect = this.$auth.redirect()
      // console.log('login')
      this.$auth.login({
        data: this.data,
        rememberMe: true,
        redirect: '/',
        fetchUser: true,
        success () {
          // console.log('success ' + this.context)
        },
        error (res) {
          // console.log('error ' + this.context, res)
          this.data.username = this.data.password = ''
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
// float: none;
margin: 150px auto;
}
</style>



// WEBPACK FOOTER //
// Login.vue?55c8c695